import { Injectable,Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Klassenbuch } from '../_models/klassenbuch';
import { KursKlassenbuch } from '../_models/KursKlassenbuch';
//import { Kursteilnehmer } from "./../_models/teilnehmer";
//import { TeilnehmerService } from "./teilnehmer.service";
//import { retry } from 'rxjs/operator/retry';
//import { element } from 'protractor';

@Injectable()
export class InhalteService
{

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string)
  {}
  getInhalte()
  {
    return this.http.get<Klassenbuch[]>(this.baseUrl + "/api/klassenbuch");

  }
  getHolidays() {
    return this.http.get<Klassenbuch[]>(this.baseUrl + "/api/klassenbuch/GetHolidays");
  }
  getInhaltebykurs(kurs)
  {
    if (kurs)
    {
      return this.http.get<Klassenbuch[]>(this.baseUrl + "/api/klassenbuch/GetKlassenbuchByKurs/" + kurs.kursNr);
    }
    else { return null;}
  }
  postInhalte(data:Klassenbuch)
  {
    return this.http.post<Klassenbuch>(this.baseUrl + "api/klassenbuch" , data);
  }
  getLeereInhalte(ort:string)
  {
    return this.http.get<any[]>(this.baseUrl + "/api/klassenbuch/GetLeereKlassenbuecher/"+ort);
  }
  GetKlassenbuchByKurs(knr) {
    return this.http.get<Klassenbuch[]>(this.baseUrl + "/api/klassenbuch/GetKlassenbuchByKurs/" + knr);
  }
  GetKlassenbuchByKursHeute(knr)
  {
    return this.http.get<Klassenbuch>(this.baseUrl + "/api/klassenbuch/GetKlassenbuchByKursHeute/" + knr);
  }
  postLookup(data)
  {
    return this.http.post(this.baseUrl + "api/KursKlassenbuch", data);
  }
  postLookupDelete(data: KursKlassenbuch) {
    return this.http.post(this.baseUrl + "api/KursKlassenbuchDelete", data);
  }
  GetLookup() {
    return this.http.get<KursKlassenbuch[]>(this.baseUrl + "api/KursKlassenbuch");
  }
  GetEntryByTrainerToday(trainerDisplayName: string) {
    return this.http.get<Klassenbuch[]>(this.baseUrl + 'api/klassenbuch/GetEntryByTrainerToday/' + trainerDisplayName);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/inhalte.service.ts